import { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Row,
  Collapse,
  Button,
} from "reactstrap";
// router
import { useLocation } from "react-router-dom";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// componentes
import GameChartPW from "./Chart";
import Pagination from "../../../components/Paginationv3";
import SearchFilters from "../../../components/SearchFilters";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import WaitExport from "../../../components/WaitExport";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
// service e utils
import {
  listGameItemsCompleted,
  getChartDataRdPw,
  deleteItemList,
  deleteAllItemList,
} from "../../../utils/services/gameRd";
import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";
// moment
import moment from "moment/moment";

export default function GameRDPW() {
  const location = useLocation();
  const idEvent = location.state.idEvent;
  const nameEvent = location.state.event.title;
  // collapse
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [dataList, setDataList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  const [activeFilter, setActiveFilter] = useState("name");
  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // dados do grafico
  const [chartData, setChartData] = useState([]);
  // loading
  const [isLoading, setIsLoading] = useState(false);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  // deletar
  const [itemSelected, setItemSelected] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  // alerta
  const [alertDelete, setAlertDelete] = useState(false);
  const [alertDeleteConfirmed, setAlertDeleteConfirmed] = useState(false);
  const [alertError, setAlertError] = useState("");
  // modal
  const [modalDeleteAll, setModalDeleteAll] = useState(false);

  const columnsFilter = [
    { name: "Nome do Participante", value: "name", type: "text" },
    { name: "Email do Participante", value: "email", type: "text" },
    { name: "Conteúdo", value: "content", type: "text" },
  ];

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  async function getListData() {
    setIsLoading(true);
    try {
      const res = await listGameItemsCompleted({
        idEvent: idEvent,
        offset: currentIndex,
        limit: itemsPerPage,
        search: debouncedSearch,
        columnSearch: activeFilter,
      });

      setCountData(res.total);
      setDataList(res.data);
    } catch (error) {
      setCountData(0);
      setDataList([]);
    } finally {
      setIsLoading(false);
    }
  }

  async function getChart() {
    try {
      const res = await getChartDataRdPw({ idEvent });

      setChartData(res.data);
    } catch (error) {
      setChartData([]);
    }
  }

  async function deleteItem() {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      const res = await deleteItemList(itemSelected.id);

      if (res.message === "DISABLED") {
        setAlertDeleteConfirmed(true);
      } else setAlertError("Erro ao deletar o conteúdo");
    } catch (error) {
      setAlertError("Erro ao deletar o conteúdo");
    } finally {
      setIsDeleting(false);
      setItemSelected(null);
      setAlertDelete(false);
    }
  }

  async function deleteAllItem() {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      const res = await deleteAllItemList(idEvent);

      if (res.message === "DISABLED") {
        setAlertDeleteConfirmed(true);
      } else setAlertError("Erro ao deletar todos os itens");
    } catch (error) {
      setAlertError("Erro ao deletar todos os itens");
    } finally {
      setIsDeleting(false);
      setAlertDelete(false);
    }
  }

  useEffect(() => {
    getListData();
  }, [debouncedSearch, itemsPerPage, currentIndex]);

  useEffect(() => {
    getChart();
  }, []);

  return (
    <>
      <WaitExport
        isOpen={exportInProgress}
        name="Game RD Pré Work"
        preposicao="do"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />

      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Itens"
          onConfirm={deleteAllItem}
        />
      )}

      {alertDelete && (
        <SweetAlert
          title={`Deseja deletar o conteúdo ${itemSelected.content} do(a) participante ${itemSelected.participantName}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={async () => {
            deleteItem();
          }}
          onCancel={() => {
            setAlertDelete(false);
            setItemSelected(null);
          }}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      )}

      {alertDeleteConfirmed && (
        <SweetAlert
          success
          erro
          title="Sucesso"
          onConfirm={() => {
            setAlertDeleteConfirmed(false);
            getListData();
            getChart();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <>
            <p>Conteúdo(s) deletado(s) com sucesso</p>
          </>
        </SweetAlert>
      )}

      <Card>
        <CardBody>
          <CardTitle>Game RD Pré Work</CardTitle>

          <GameChartPW chartData={chartData} />

          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form className="app-search" style={{ padding: "0px" }}>
                  <div className="position-relative">
                    <input
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              {dataList.length > 0 && (
                <>
                  <SectionComponent
                    sectionName="Opções"
                    setIsOpen={setIsOpen}
                    isOpen={isOpen}
                  />

                  <Collapse isOpen={isOpen}>
                    <Row className="mobile-btns-top">
                      <div
                        onClick={() =>
                          createXlsx({
                            idEvent: idEvent,
                            nameEvent: nameEvent,
                            limit: 999999,
                            countData,
                            setFinishExport,
                          }) > setExportInProgress(true)
                        }
                      >
                        Exportar Relatório
                      </div>
                    </Row>
                  </Collapse>
                </>
              )}
            </div>

            <div className="header-btns-container">
              {dataList.length > 0 && (
                <>
                  <Button
                    color="success"
                    className="btn-rounded waves-effect waves-light events-button-add"
                    onClick={() =>
                      createXlsx({
                        idEvent: idEvent,
                        nameEvent: nameEvent,
                        limit: 999999,
                        countData,
                        setFinishExport,
                      }) > setExportInProgress(true)
                    }
                  >
                    Exportar Relatório
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nome do Participante</th>
                  <th>Email do Participante</th>
                  <th>Conteúdo</th>
                  <th>Respostas Certas x Total</th>
                  <th>Data e Hora</th>
                  <th>Ação</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={6} />
                ) : (
                  dataList &&
                  dataList.length > 0 &&
                  dataList.map((e, i) => (
                    <tr key={i}>
                      <td>{e.participantName}</td>
                      <td>{e.participantEmail}</td>
                      <td>{e.content}</td>
                      <td>{`${e.correctAnswers} / ${e.totalAnswers}`}</td>
                      <td>{moment(e.dateTime).format("DD/MM/YYYY H:mm")}</td>
                      <td>
                        <DeleteButton
                          onClick={async () => {
                            setItemSelected(e);
                            setAlertDelete(true);
                          }}
                          color="red"
                          fontSize={17}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            dataList?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {dataList.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Conteúdos"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}
        <Pagination
          data={dataList}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>

      {/* <div
        className="bottom-navigation"
        style={{
          justifyContent: "end",
        }}
      >
        <Pagination
          data={dataList}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div> */}
    </>
  );
}
